import React from 'react';
import PropTypes from 'prop-types';
import BaseMarker from '../BaseMarker';
import {LANDINGAPP_MARKER_ICON, MAP_PIN_TYPES} from '../../../utils/markers';

const colors = {
    blue: '#0067db',
    white: '#fff',
    labelColor: '#5E6D77',
};

const DestinationMarker = ({
    id,
    position,
    label: labelText,
    zIndex,
    onClick,
    isHighlighted,
    map,
}) => {
    const label = {
        fontSize: '14px',
        fontWeight: 'bold',
        color: isHighlighted ? colors.white : colors.labelColor,
        text: labelText,
    };

    const icon = {
        ...LANDINGAPP_MARKER_ICON.DESTINATION,
        fillColor: isHighlighted ? colors.blue : colors.white,
    };

    return (
        <BaseMarker
            map={map}
            position={position}
            label={label}
            zIndex={zIndex}
            id={id}
            icon={icon}
            onClick={onClick}
            isHighlighted={isHighlighted}
            pinType={MAP_PIN_TYPES.DESTINATION}
        />
    );
};

export default DestinationMarker;

DestinationMarker.propTypes = {
    map: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    position: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired,
    }).isRequired,
    labelText: PropTypes.string,
    isHighlighted: PropTypes.bool,
    zIndex: PropTypes.number,
};
